var LayoutLista = (function () {

  /* ---------------------------------------------------------
  LAYOUT SINGLE PROGETTO
  --------------------------------------------------------- */

  var progetto = function (post, idEdizione) {

    output = '';



    return output;

    /* ^ FINE PROGETTO ----------------------------------------- */
  };



  /* ---------------------------------------------------------
  LAYOUT SINGLE EVENTO / PROGETTO
  --------------------------------------------------------- */

  var eventoProgetto = function (post, idEdizione) {

    output = '';

    output += '<div class="'+post.list_classes+' blog-'+idEdizione+'">';
      output += '<a class="row" href="'+post.permalink+'">';

        output += '<div class="text-uppercase col-15 col-sm-4 par-1">'+post.tipo_di_post+'</div>';
        output += '<div class="col-15 col-sm-9 par-2">'+post.title+'</div>';

        output += '<div class="col-15 col-sm-2 d-flex flex-column flex-lg-row justify-content-center justify-content-lg-end text-right align-content-center">';
          if($('body').hasClass('pc_logged')){
            output += post.love_button;
            // output += '<div id="love-'+post.tipo_di_post+'-'+post.id+'" class="love-button" data-id="'+post.id+'" data-type="'+post.tipo_di_post+'" data-blog="'+idEdizione+'">';
            //   output += '<i class="fal fa-heart text-primary"></i>';
            // output += '</div>';
          }
          output += '<i class="d-none d-lg-flex fal fa-sign-in text-primary float-right ms-3"></i>';
          // output += '<div class="love-'+post.tipo_di_post+'-'+post.id+' love-button'" data-id="' . $rw_post_id . '" data-type="' . $rw_post_type . '" data-blog="' . $rw_blog_id . '">';
        output += '</div>';

      output += '</a>';
    output += '</div>';

    return output;

    /* ^ FINE EVENTO ----------------------------------------- */
  };



  /* ---------------------------------------------------------
  LAYOUT SINGLE CONTRIBUTO
  --------------------------------------------------------- */

  var contributo = function (post, idEdizione) {

    output = '';


    output += '<div class="'+post.list_classes+' blog-'+idEdizione+'">';
      if (post.tipo_contributo == 'video') {
        output += '<a class="row" data-fancybox href="'+post.contributo_video+'">';
      } else {
        output += '<a class="row" data-src="#contributo-'+post.id+'" data-fancybox href="javascript:;">';
      }

        output += '<div class="text-uppercase col-15 col-sm-4 par-1">'+post.tipo_di_post+'</div>';
        output += '<div class="col-15 col-sm-9 par-2">';

          if (post.contributo_cognome !== '' && post.contributo_cognome !== null && post.contributo_cognome !== undefined ) {
            output += post.contributo_nome+' '+post.contributo_cognome;
          }
          output += ' '+post.title;

        output += '</div>';


        output += '<div class="col-15 col-sm-2 d-flex flex-column flex-lg-row justify-content-center justify-content-lg-end text-right align-content-center">';
          if($('body').hasClass('pc_logged')){
            output += post.love_button;
          }
          output += '<i class="d-none d-lg-flex fal fa-sign-in text-primary float-right ms-3"></i>';
        output += '</div>';

        if (post.tipo_contributo == 'testo') {
          output += '<div class="fancy-modale-html" style="display: none;" id="contributo-'+post.id+'">';
            output += '<div class="container p-sm-5">';
              if (post.contributo_cognome !== ''
                && post.contributo_cognome !== null
                && post.contributo_cognome !== undefined ) {
                  output += '<h3 class="h3 me-auto mb-4">'+post.contributo_nome+' '+post.contributo_cognome+'</h3>';
              }
              output += '<h2 class="h2 mb-5 fw-700">'+post.title+'</h2>';
              output += '<div class="contenuto">';
                output += post.contributo_testo;
              output += '</div>';
            output += '</div>';
          output += '</div>';
        }

      output += '</a>';
    output += '</div>';


    return output;

    /* ^ FINE CONTRIBUTO ----------------------------------------- */
  };


  return {
    progetto : progetto,
    eventoProgetto : eventoProgetto,
    contributo : contributo
  }


})();
